import './Contact.scss';

const Contact = (props) => {
  return (
    <div className='contact-container'>
      <h1>Contactez-nous</h1>
      <p>Par courriel: blogreact_@_gmail.com</p>
      <p>Par téléphone : xx-xx-xx-xx-xx</p>
      <p>Rejoignez-vous sur les réseaux</p>
      <ul>
        <li>Facebook</li>
        <li>Twitter</li>
        <li>Youtube</li>
      </ul>
    </div>
  );
}

export default Contact;